export default __webpack_public_path__ + "static/media/support 1.3b9226ec.svg";